import { IDocumentResource } from '@/api/resources/types/document-resource';
import { EDocumentPageType } from '@lib-shared/enums/document-page-type';
import { ERecipientRole } from '@lib-shared/recipients/types/enums/recipient-role';
import { IDocumentPage } from '@lib-shared/types/document-page';
import { IRecipient } from '@lib-shared/types/Recipient';

export class AssemblerHelper {
  static getSignableRecipients(recipients: IRecipient[]) {
    return recipients.filter((recipient: IRecipient) =>
      [ERecipientRole.Approver, ERecipientRole.Signer].includes(recipient.role as ERecipientRole)
    );
  }

  static getCurrentDocumentPageAfterPageDelete(
    deletedPageIndex: number,
    pages: IDocumentPage[]
  ): IDocumentPage {
    let nextCurrentDocumentPage: IDocumentPage = pages[deletedPageIndex];
    if (!nextCurrentDocumentPage) {
      nextCurrentDocumentPage = pages[deletedPageIndex - 1];
    }
    return nextCurrentDocumentPage;
  }

  static updatePageNums(
    pages: IDocumentPage[],
    newPageNums: Partial<IDocumentPage>[]
  ): IDocumentPage[] {
    return pages
      .map((page: IDocumentPage) => ({
        ...page,
        pageNum: newPageNums.find(pageNum => pageNum.id === page.id).pageNum,
      }))
      .sort((a: IDocumentPage, b: IDocumentPage): number => a.pageNum - b.pageNum);
  }

  static mapDocumentResources(
    pages: IDocumentPage[],
    documentResources: IDocumentResource[]
  ): IDocumentPage[] {
    return pages.map((page: IDocumentPage) => {
      let resourceId = '';
      switch (page.pageType) {
        case EDocumentPageType.Editor: {
          if (!page.editorBlock) {
            break;
          }
          resourceId = AssemblerHelper.findResourceId(documentResources, page.editorBlock.id);
          break;
        }
        case EDocumentPageType.ContentLink: {
          if (!page.contentLinkBlock) {
            break;
          }
          resourceId = AssemblerHelper.findResourceId(documentResources, page.contentLinkBlock.id);
          break;
        }
        case EDocumentPageType.Video: {
          if (!page.video) {
            break;
          }
          resourceId = AssemblerHelper.findResourceId(documentResources, page.video.id);
          break;
        }
        default:
          break;
      }
      return { ...page, resourceId };
    });
  }

  static sortRecipients(recipients: IRecipient[]): IRecipient[] {
    return recipients.sort((a: IRecipient, b: IRecipient) => {
      if (a.role === ERecipientRole.Approver) {
        return -1;
      }
      if (b.role !== ERecipientRole.Approver) {
        return 1;
      }
    });
  }

  static orderRecipients(recipients: IRecipient[]): Partial<IRecipient>[] {
    return recipients.map((recipient, i) => ({ id: recipient.id, orderNum: i + 1 }));
  }

  private static findResourceId(resources: IDocumentResource[], blockId: string): string {
    return resources.find((resource: IDocumentResource) => resource.contentId === blockId)
      ?.resourceId;
  }
}
